export type ShoppingCategory =
  | 'seed'
  | 'fertilizer'
  | 'equipment'
  | 'chemicals'
  | 'ammunition'
  | 'minerals'
  | 'other';

export const SHOPPING_CATEGORIES: { value: ShoppingCategory; label: string }[] = [
  { value: 'seed', label: 'Seed' },
  { value: 'fertilizer', label: 'Fertilizer' },
  { value: 'equipment', label: 'Equipment' },
  { value: 'chemicals', label: 'Chemicals' },
  { value: 'ammunition', label: 'Ammunition' },
  { value: 'minerals', label: 'Minerals' },
  { value: 'other', label: 'Other' },
];

export interface ShoppingListItem {
  id: string;
  propertyId?: string;
  taskId?: string; // FK → Task (task that generated this item)
  name: string;
  quantity?: number;
  unit?: string;
  category?: string;
  estimatedCost?: number;
  purchased: boolean;
  purchasedAt?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export type CreateShoppingListItemInput = Omit<ShoppingListItem, 'id' | 'createdAt' | 'updatedAt'>;
export type UpdateShoppingListItemInput = Partial<CreateShoppingListItemInput>;
